__turbopack_context__.v({
  "h1": "GrDoc-module__kK8YJG__h1",
  "inner": "GrDoc-module__kK8YJG__inner",
  "page": "GrDoc-module__kK8YJG__page",
  "promo": "GrDoc-module__kK8YJG__promo",
});
